"use strict";
/** Copyright (c) 2025 DAIA Tech Pvt Ltd. All rights reserved.
 *
 * This software is confidential and proprietary information of DAIA Tech Pvt Ltd
 * and its licensors. You shall not disclose such Confidential Information and shall
 * use it only in accordance with the terms of the license agreement.
 *
 * Unauthorized reproduction, modification, distribution, or disclosure of this
 * software is strictly prohibited.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getComponentParameters = getComponentParameters;
const Index_1 = require("../Index");
function assertUnreachable(_x) {
    console.error("Didn't expect to get here");
}
function getUserComponentParameters(component) {
    switch (component.dtype) {
        case 'TEXT':
            return Index_1.UserTextComponentParameters;
        case 'AUDIO':
            return Index_1.UserAudioComponentParameters;
        case 'MCQ':
            return Index_1.UserMCQComponentParameters;
        case 'IMAGE':
            return Index_1.UserImageComponentParameters;
        case 'VIDEO':
            return Index_1.UserVideoComponentParameters;
        case 'VIDEO_MULTI':
            return Index_1.UserVideoMultiComponentParameters;
        case 'BOOLEAN':
            return Index_1.UserBooleanComponentParameters;
        case 'AUDIO_SEGMENTATION':
            return Index_1.UserAudioSegmentationParameters;
        case 'AUDIO_MARKER':
            return Index_1.UserAudioMarkerParameters;
        case 'TEXT_SELECT':
            return Index_1.UserTextSelectComponentParameters;
        case 'TAGS':
            return Index_1.UserTagsComponentParameters;
        case 'OPEN':
            return Index_1.UserOpenComponentParameters;
        case 'TEXT_SELECT_MULTI':
            return Index_1.UserMultiTextSelectComponentParameters;
        case 'AUDIO_TRANSCRIPTION':
            return Index_1.UserAudioTranscriptionComponentParameters;
        case 'REFER_WORKER':
            return Index_1.UserReferWorkerComponentParameters;
        case 'DATE':
            return Index_1.UserDateComponentParameters;
        case 'IMAGE_ANNOTATION':
            return Index_1.UserImageAnnotationComponentParameters;
        case 'FILL_BLANK':
            return Index_1.UserFillInBlanksComponentParameters;
        case 'WORD_CLOUD':
            return Index_1.UserWordCloudComponentParameters;
        case 'USER_ID_CAPTURE':
            return Index_1.UserIdCaptureComponentParameters;
        case 'LOCALE_BOOLEAN':
            return Index_1.UserLocaleBooleanComponentParameters;
        case 'PRP_TEXT_COMPARISON':
            return Index_1.UserPRPTextComparisonComponentParameters;
        case 'CONFERENCER_VOIP_CALLER':
            return Index_1.UserConferencerVoipCallerComponentParameters;
        default:
            assertUnreachable(component);
            return null;
    }
}
function getPlatformComponentParameters(component) {
    switch (component.dtype) {
        case 'AUDIO':
            return Index_1.PlatformAudioComponentParameters;
        case 'TEXT':
            return Index_1.PlatformTextComponentParameters;
        case 'IMAGE':
            return Index_1.PlatformImageComponentParameters;
        case 'VIDEO':
            return Index_1.PlatformVideoComponentParameters;
        case 'IMAGE_MASK':
            return Index_1.PlatformImageMaskComponentParameters;
        case 'LOCALE_TEXT':
            return Index_1.PlatformLocaleTextComponentParameters;
        case 'OPEN':
            return Index_1.PlatformOpenComponentParameters;
        default:
            assertUnreachable(component);
            return null;
    }
}
function getBackgroundServerComponentParameters(component) {
    switch (component.function_id) {
        case 'CREATE_DEGRADED_STR_COPY':
            return Index_1.CreateDegradedStrCopyComponentParameters;
        case 'LANGUAGE_MISMATCH':
            return Index_1.LanguageMismatchComponentParameters;
        case 'AUDIO_BG_NOISE_CHECK':
            return Index_1.AudioBgNoiseCheckComponentParameters;
        default:
            return [];
    }
}
function getBackgroundLocalComponentParameters(component) {
    switch (component.function_id) {
        case 'SEGMENT_AUDIO':
            return Index_1.SegmentAudioLocalComponentParameters;
        case 'CHECK_AUDIO_CLIPPING':
            return Index_1.CheckClippingLocalComponentParameters;
        case 'ARRAY_FILTER':
            return Index_1.ArrayFilterLocalComponentParameters;
        case 'NULL_CHECK':
            return Index_1.NullCheckLocalComponentParameters;
        case 'GET_USER_LOCATION':
            return Index_1.BgAPIUserLocationComponentParameters;
        case 'INCREMENT_INT':
            return Index_1.BgLocalIncrementIntComponentParameters;
        case 'FETCH_DISTRICT_NAMES':
            return Index_1.BgLocalFetchDistrictNamesComponentParameters;
        case 'CHECK_IN_RANGE':
            return Index_1.BgLocalCheckInRangeComponentParameters;
        case 'CHECK_ELIGIBILITY':
            return Index_1.BgLocalCheckEligibilityComponentParameters;
        case 'ARRAY_PUSH':
            return Index_1.BgLocalArrayPushComponentParameters;
        case 'COPY':
            return Index_1.BgLocalCopyComponentParameters;
        default:
            assertUnreachable(component);
            return null;
    }
}
function getLoopComponentParameters(component) {
    switch (component.ltype) {
        case 'WHILE':
            return Index_1.WhileLoopComponentParameters;
        case 'FOR':
            return Index_1.ForLoopComponentParameters;
        default:
            assertUnreachable(component);
            return null;
    }
}
function getComponentParameters(component) {
    switch (component.ctype) {
        case 'USER':
            return getUserComponentParameters(component);
        case 'PLATFORM':
            return getPlatformComponentParameters(component);
        case 'BACKGROUND_LOCAL':
            return getBackgroundLocalComponentParameters(component);
        case 'BACKGROUND_SERVER':
            return getBackgroundServerComponentParameters(component);
        case 'BATCH_BACKGROUND_SERVER':
            return getBackgroundServerComponentParameters(component);
        case 'LOOP':
            return getLoopComponentParameters(component);
        case 'START':
        case 'END':
            return [];
        default:
            assertUnreachable(component);
            return null;
    }
}
//# sourceMappingURL=ParameterDefinitions.js.map